import { AlertTriangle } from 'lucide-react';
import { Button } from '../primitives/button';
import { cn } from '../lib/cn';

interface ErrorStateProps {
  title?: string;
  /** What went wrong and what the user can do */
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  /** Request id from the API error, so support can find the log */
  requestId?: string;
  className?: string;
}

export function ErrorState({
  title = 'Could not load this',
  message,
  onRetry,
  retryLabel = 'Try again',
  requestId,
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center gap-3 rounded-xl border border-danger/30 bg-danger/5 px-6 py-10 text-center',
        className,
      )}
    >
      <AlertTriangle className="size-8 text-danger" />
      <div className="grid gap-1">
        <h2 className="font-semibold">{title}</h2>
        <p className="max-w-md text-sm text-muted-foreground">{message}</p>
        {requestId && <p className="font-mono text-xs text-muted-foreground">Ref: {requestId}</p>}
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
